import React from 'react'
import PropTypes from 'prop-types'
import I18n from '/src/utils/translations'
import { MdLocationOn } from 'react-icons/md'

export default function GPSColumn({ value }) {
  if (!value) {
    return <span className="text-gray-400">{I18n.t('form.inputs.gps.no_location')}</span>
  }

  try {
    const [latitude, longitude] = JSON.parse(value)
    if (!latitude || !longitude) {
      return <span className="text-gray-400">{I18n.t('form.inputs.gps.location_not_found')}</span>
    }

    return (
      <div className="flex items-center gap-1">
        <MdLocationOn className="text-green-500" size={14} />
        <span className="text-sm">
          {parseFloat(latitude).toFixed(6)}, {parseFloat(longitude).toFixed(6)}
        </span>
      </div>
    )
  } catch {
    return <span className="text-gray-400">{I18n.t('form.inputs.gps.invalid_location')}</span>
  }
}

GPSColumn.propTypes = {
  value: PropTypes.string
}

GPSColumn.defaultProps = {
  value: null
}
